/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/unlock'
export default icon
